
import PortfolioPrivacyTag from '@/components/ui/atom/PortfolioPrivacyTag.vue';
import ChangePercent from '@/components/ui/atom/ChangePercent.vue';
import PortfolioRankTag from '@/components/ui/atom/PortfolioRankTag.vue';
import { getDateFromNow } from '~/utils/portfolio-dates';
export default {
  name: 'UIMobileHorizontalPortfolioCard',
  components: { PortfolioPrivacyTag, ChangePercent, PortfolioRankTag },
  props: {
    isPublicPortfolio: {
      type: Boolean,
      required: true,
    },
    rank: {
      type: Number,
      required: false,
      default: -1,
    },
    inUnrankedState: {
      type: Boolean,
      required: false,
      default: false,
    },
    portfolioName: {
      type: String,
      required: true,
    },
    portfolioCurrency: {
      type: String,
      default: '',
    },
    portfolioCost: {
      type: Number,
      default: 0,
    },
    portfolioMarketValue: {
      type: Number,
      default: 0,
    },
    portfolioDailyReturnPercent: {
      type: Number,
      default: 0,
    },
    portfolioOverallReturn: {
      type: Number,
      default: 0,
    },
    portfolioOverallReturnPercent: {
      type: Number,
      default: 0,
    },
    portfolioLineCount: {
      type: Number,
      required: true,
    },
    lastUpdated: {
      type: String,
      required: true,
    },
    showSelectedIndicator: {
      type: Boolean,
      required: false,
    },
    selectedIndicatorColor: {
      type: String,
      required: false,
      default: 'primary-6',
    },
    isInPrivateLeague: {
      type: Boolean,
      default: false,
    },
    leagueId: {
      type: String,
      default: null,
    },
    leagueAvatarUri: {
      type: String,
      default: null,
    },
  },
  computed: {
    lastUpdatedFromNow() {
      return getDateFromNow(this.lastUpdated, this.$dayjs);
    },
  },
};
